import { Box, Image, SimpleGrid, Text, Title } from "@repo/ui/core";
import classes from "@styles/onsite.module.css";
import { motion } from "framer-motion";

type Props = {
  title?: string;
  subtitle?: string;
};

const CAR_IMAGES = [
  { src: "/assets/images/cars/001.png", alt: "Vehicle 1" },
  { src: "/assets/images/cars/002.jpg", alt: "Vehicle 2" },
  { src: "/assets/images/cars/004.jpeg", alt: "Vehicle 3" },
  { src: "/assets/images/cars/005.jpg", alt: "Vehicle 4" },
  { src: "/assets/images/cars/006.jpg", alt: "Vehicle 5" },
  { src: "/assets/images/cars/008.jpg", alt: "Vehicle 6" },
  { src: "/assets/images/cars/010.jpg", alt: "Vehicle 7" },
  { src: "/assets/images/cars/011.jpg", alt: "Vehicle 8" },
  { src: "/assets/images/cars/012.jpg", alt: "Vehicle 9" },
  { src: "/assets/images/cars/013.jpg", alt: "Vehicle 10" },
  { src: "/assets/images/cars/014.jpeg", alt: "Vehicle 11" },
  { src: "/assets/images/cars/015.png", alt: "Vehicle 12" },
];

export function ImageGridSlide({ title, subtitle }: Props) {
  return (
    <Box w="100%" maw={1400} px="xl">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {title && (
          <Title
            order={2}
            ta="center"
            mb="sm"
            size="clamp(30px, 4vw, 52px)"
            fw={700}
            className={classes.gradientTextAccent}
          >
            {title}
          </Title>
        )}
        {subtitle && (
          <Text size="lg" c="dimmed" ta="center" mb="xl">
            {subtitle}
          </Text>
        )}
        <SimpleGrid cols={{ base: 2, sm: 4 }} spacing="md">
          {CAR_IMAGES.map((car, i) => (
            <motion.div
              key={car.src}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
            >
              <Box
                className={classes.cardElevated}
                style={{ overflow: "hidden" }}
              >
                <Image
                  src={car.src}
                  alt={car.alt}
                  h="clamp(120px, 18vh, 200px)"
                  fit="cover"
                  radius="md"
                />
              </Box>
            </motion.div>
          ))}
        </SimpleGrid>
      </motion.div>
    </Box>
  );
}
